import { useTranslation } from 'react-i18next';
import { featuredProducts } from '@/mocks/categories';
import { useRef } from 'react';

export default function ProductShowcase() {
  const { t } = useTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-start justify-between mb-10">
          <div>
            <p className="text-sm text-foreground-400 font-semibold uppercase tracking-wider mb-3">
              {t('showcase.title1', 'Популярные')}{' '}
              <span className="text-primary-500">{t('showcase.highlight', 'YOYBUY')}</span>{' '}
              {t('showcase.title2', 'товары')}
            </p>
            <p className="text-sm text-foreground-500 max-w-md">
              {t('showcase.subtitle', 'Лучшие предложения этой недели')}
            </p>
          </div>
          <div className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
            {t('showcase.badge', 'YOYBUY Sheet')}
          </div>
          <div className="flex items-center gap-2 sm:hidden">
            <button
              onClick={() => scroll('left')}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-foreground-950 hover:text-background-50 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-foreground-950 hover:text-background-50 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll('left')}
            className="hidden sm:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-foreground-950 hover:text-background-50 transition-all duration-200 cursor-pointer -ml-5"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button
            onClick={() => scroll('right')}
            className="hidden sm:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-foreground-950 hover:text-background-50 transition-all duration-200 cursor-pointer -mr-5"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scrollbar-hide pb-2"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {featuredProducts.map((product) => (
              <div
                key={product.id}
                className="flex-shrink-0 w-[260px] md:w-[280px] rounded-2xl bg-background-50 overflow-hidden"
                style={{ scrollSnapAlign: 'start' }}
              >
                <div className="w-full h-[260px] md:h-[280px] overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="p-4">
                  <p className="text-xs text-foreground-500 mb-1">{product.name}</p>
                  <p className="text-xs text-foreground-400 mb-3">{product.desc}</p>
                  <p className="text-lg font-bold text-foreground-950">{product.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}